import styled from '@emotion/styled';
import tw from 'twin.macro';
import Button from './Button';

const RedText = styled(Button)`
  ${tw`text-color-delete`}
`;

export default RedText;
